function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 69,
  height: 47,
  rx: 5.5,
  fill: "white",
  stroke: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.09 38.9999C45.8851 39.0376 53 32.5843 53 24.734C53 16.15 45.8851 10.2158 38.09 10.219H31.3813C23.4933 10.2158 17 16.1516 17 24.734C17 32.5859 23.4933 39.0376 31.3813 38.9999H38.09Z",
  fill: "#0079BE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4133 11.4084C24.2047 11.4109 18.3642 17.3066 18.3618 24.5833C18.3642 31.8593 24.2047 37.755 31.4133 37.7574C38.6228 37.755 44.4656 31.8593 44.4664 24.5833C44.4656 17.3066 38.6236 11.4109 31.4133 11.4084ZM23.1409 24.5833C23.1394 22.9009 23.6454 21.2571 24.593 19.8668C25.5405 18.4766 26.8854 17.4045 28.4518 16.7907V32.3751C26.8852 31.7618 25.5402 30.6899 24.5926 29.2997C23.6451 27.9095 23.1391 26.2657 23.1409 24.5833ZM34.374 32.3783V16.7899C35.9417 17.4028 37.2877 18.4748 38.2359 19.8655C39.1841 21.2563 39.6903 22.9009 39.6882 24.5841C39.69 26.2673 39.1837 27.9118 38.2355 29.3024C37.2873 30.6931 35.9415 31.7651 34.374 32.3783Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38.09 38.9999C45.8851 39.0376 53 32.5843 53 24.734C53 16.15 45.8851 10.2158 38.09 10.219H31.3813C23.4933 10.2158 17 16.1516 17 24.734C17 32.5859 23.4933 39.0376 31.3813 38.9999H38.09Z",
  fill: "#0079BE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4133 11.4084C24.2047 11.4109 18.3642 17.3066 18.3618 24.5833C18.3642 31.8593 24.2047 37.755 31.4133 37.7574C38.6228 37.755 44.4656 31.8593 44.4664 24.5833C44.4656 17.3066 38.6236 11.4109 31.4133 11.4084ZM23.1409 24.5833C23.1394 22.9009 23.6454 21.2571 24.593 19.8668C25.5405 18.4766 26.8854 17.4045 28.4518 16.7907V32.3751C26.8852 31.7618 25.5402 30.6899 24.5926 29.2997C23.6451 27.9095 23.1391 26.2657 23.1409 24.5833ZM34.374 32.3783V16.7899C35.9417 17.4028 37.2877 18.4748 38.2359 19.8655C39.1841 21.2563 39.6903 22.9009 39.6882 24.5841C39.69 26.2673 39.1837 27.9118 38.2355 29.3024C37.2873 30.6931 35.9415 31.7651 34.374 32.3783Z",
  fill: "white"
});

function SvgDinersClub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/diners_club.2291ab4e.svg";
export { ForwardRef as ReactComponent };